const topics = [
  { id: 1, label: '最新院线大片', count: '2.3万讨论', hot: true },
  { id: 2, label: '悬疑推理剧推荐', count: '1.8万讨论', hot: true },
  { id: 3, label: '高分经典电影', count: '1.5万讨论', hot: false },
  { id: 4, label: '热播电视剧', count: '3.1万讨论', hot: true },
  { id: 5, label: '国产影视精选', count: '1.2万讨论', hot: false },
  { id: 6, label: '动作大片合集', count: '9.8千讨论', hot: false },
  { id: 7, label: '喜剧电影推荐', count: '1.6万讨论', hot: false },
  { id: 8, label: '科幻奇幻专区', count: '2.0万讨论', hot: true },
  { id: 9, label: '综艺节目精华', count: '8.5千讨论', hot: false },
  { id: 10, label: '每日更新片单', count: '4.2万讨论', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              热门话题
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              影视爱好者正在热议的焦点话题
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((topic) => (
              <div
                key={topic.id}
                className={`group flex items-center gap-2 px-5 py-3 rounded-full border cursor-pointer transition-all duration-300 ${
                  topic.hot
                    ? 'bg-accent-50 border-accent-200 hover:bg-accent-100'
                    : 'bg-background-100 border-background-200 hover:bg-background-200'
                }`}
              >
                {topic.hot && (
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-fire-line text-accent-500 text-sm"></i>
                  </span>
                )}
                <span className={`text-sm font-medium whitespace-nowrap ${topic.hot ? 'text-accent-700' : 'text-foreground-700'}`}>
                  {topic.label}
                </span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.count}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}